<template>
  <li class="search-result search-address-result" @click="itemClicked" aria-label="Vis rute til adressen">
    <span class="float-left">
      {{ resultData.name }}
    </span>
    <span class="float-right">
      <span class="small-text"><em>{{ type }}</em></span>
    </span>
  </li>
</template>

<script>

export default {
  data() {
    return {
      type: ''
    }
  },
  props: {
    resultData: {
      type: Object,
      required: true
    },
    tagList: {
      type: Object,
      required: true
    }
  },
  created() {
    this.createData();
  },
  updated() {
    this.createData();
  },
  methods: {
    createData() {
      if (this.$props.resultData.type === 'husnummer') {
        //
        this.type = 'Adresse';
      } else if (this.$props.resultData.type === 'navngivenvejpostnummer') {
        //
        this.type = this.$props.resultData.code+", "+this.$props.resultData.comune;
      } else if (this.$props.resultData.type === 'item') {
        //
        this.type = this.tagList[parseInt(this.$props.resultData.tagId)].name;
      } else {
        //
        this.type = this.$props.resultData.type;
      }
    },
    itemClicked() {
      this.$emit('searchResultClicked', this.$props.resultData);
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-address-result {
    color: #00708d;
  }

  .search-address-result span {
    pointer-events: none;
  }

  .search-result {
  	border-bottom: 1px solid rgba(190, 190, 190, 0.5);
  	line-height: 40px;
    min-height: 40px;
    vertical-align: middle;
  	padding: 0px 5px;
  	clear: both;
  	display: inline-block;
  	width: 100%;
    cursor: pointer;
  }

  @media screen and (min-width: 767px) {
  	.search-result {
  		padding: 0px;
  	}
  }

  .long-search-result {
  	max-width: 45%;
    line-height: 23px;
  	padding-top: 10px;
    padding-bottom: 10px;
  }

  .long-search-result:first-child {
  	max-width: 55%;
    min-height: 50px;
  }
</style>
